import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CompanyCurrencyService = {
  async getByCurrencyCode(code, params) {
    const requestScreenData = {
      url: "api/CompanyCurrency",
      top: "1",
      filter: `CurrencyCode eq '${code}'`,
    };
    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  async getByCompanyCode(code) {
    const requestScreenData = {
      url: "api/CompanyCurrency",
      top: "1",
      filter: `CompanyCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getByCompanyCodeAndCurrencyCode(companyCode, currencyCode) {
    const requestScreenData = {
      url: "api/CompanyCurrency",
      top: "1",
      filter: `CompanyCode eq '${companyCode}' and CurrencyCode eq '${currencyCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { CompanyCurrencyService };
